import globalAxios from "../GlobalAxios";


const fetchData = async (data) => {
    try {
        const res = await globalAxios.post('/api/player/fetch-data', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
        throw error;
    }
}

const heartbeat = async (data) => {
    const res = await globalAxios.post('/api/player/heartbeat', data, {
        timeout: 8000,
    });
    return res.data;
}

const updateLocation = async (data) => {
    try {
        const res = await globalAxios.post('/api/player/update-data', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const finishCheck = async (data) => {
    try {
        const res = await globalAxios.post('/api/player/update-finish', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

const playStart = async (data) => {
    try {
        const res = await globalAxios.post('/api/player/play-start', data);
        return res.data;
    } catch (error) {
        console.error("error", error);
    }
}

export default {
    fetchData,
    heartbeat,
    updateLocation,
    finishCheck,
    playStart
};